import React, { useState } from "react";
import { Lightbulb, ChevronDown, ChevronUp } from "lucide-react";

/**
 * Inline FAQ card for a wizard section. Renders the small set of tips an
 * admin has curated for this section (typically promoted from past
 * help-request resolutions). Collapsed by default — clients open it only
 * when they need it.
 */
export default function SectionTipsCard({ tips }) {
  const [open, setOpen] = useState(false);
  if (!tips || tips.length === 0) return null;

  return (
    <div
      className="mb-5 rounded-xl border border-[#00C7FF]/30 bg-gradient-to-br from-[#0F1644] to-[#1a2270] overflow-hidden shadow-md"
      data-testid="section-tips-card"
    >
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className="w-full px-5 py-3 flex items-center justify-between gap-3 text-left hover:bg-white/[0.04] transition"
        data-testid="section-tips-toggle"
      >
        <div className="flex items-center gap-2.5 min-w-0">
          <div className="w-7 h-7 rounded-md bg-[#00C7FF]/15 flex items-center justify-center shrink-0">
            <Lightbulb size={14} className="text-[#00C7FF]"/>
          </div>
          <div className="min-w-0">
            <div className="text-[11px] uppercase tracking-[0.18em] text-[#00C7FF] font-semibold">Tips for this section</div>
            <div className="text-sm text-white font-medium truncate">
              {tips.length === 1 ? tips[0].title : `${tips.length} answers from past clients`}
            </div>
          </div>
        </div>
        {open ? <ChevronUp size={16} className="text-white/70 shrink-0"/> : <ChevronDown size={16} className="text-white/70 shrink-0"/>}
      </button>
      {open && (
        <div className="px-5 pb-5 space-y-3" data-testid="section-tips-content">
          {tips.map(t => (
            <div key={t.id} className="bg-white/5 border border-white/10 rounded-lg p-3.5" data-testid={`section-tip-${t.id}`}>
              <div className="text-[13px] font-semibold text-white">{t.title}</div>
              {t.question && t.question !== t.title && (
                <div className="text-xs text-white/60 italic mt-1">&ldquo;{t.question}&rdquo;</div>
              )}
              <div className="text-sm text-white/85 leading-relaxed mt-2 whitespace-pre-wrap break-words">{t.response}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
